"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRfiInterstitial = void 0;
var useRfiInterstitial_hook_1 = require("./useRfiInterstitial.hook");
Object.defineProperty(exports, "useRfiInterstitial", { enumerable: true, get: function () { return useRfiInterstitial_hook_1.useRfiInterstitial; } });
//# sourceMappingURL=index.js.map